import { useState } from 'react'
import { Link } from 'react-router-dom'

import { useSyncMaps } from '../map/hooks'
import MapSection from '../map/components/MapSection'

import { useCurrentDetails } from '../map/hooks'

import MAP_DATA from '../map_data'
import { BASE_URL } from '../constants'

import './css/map-your-move.css'
import './css/mym-map-layers.css'
import './css/mym-navigation.css'
import './cssom/mym-details.css'

function MainPage({ acceptedDisclaimer, acceptDisclaimer, declineDisclaimer }) {
  useSyncMaps(MAP_DATA.length)

  const selectedDetailsIndex = useState(0)
  const detailsInfo = useCurrentDetails(selectedDetailsIndex[0])

  return (
    <>    
      <div className="background"></div>
      <nav>
        <div className="wrapper--nav">
          <div className="mym--logo">
            <a href="https://www.horrycounty.org" target="blank"><img src={`images/HC-circle-icon.svg`} alt="HC Government Icon" /></a>
            <Link to="/">
              <span>HC</span>
              <span className="logo-bold">Map Your Move</span>
            </Link>
          </div>
          <ul >
          <li className="dropdown">
                
                <a className="hamburger--wrapper"><div className="hamburger"><span>Maps</span></div></a>
                <ul className="map--listings">
                  {MAP_DATA.map(({ title, anchor }, index) => 
                    <li key={index}><a href={`${BASE_URL}#${anchor}`}>{title}</a></li>)}
                </ul>
              </li>
            <li>
              <Link to="/flood-info">Flood Info</Link>
            </li>
              

        </ul>
        </div>
      </nav>
      <header>
        <div className="hero--image">
          <img src="images/hero.png" alt="map depiction" />
        </div>
        <div className="wrapper--overlap">
          <div className="button--backer">
            <button className="button--push">
              <img className="button--icon" src={`${BASE_URL}images/map-pin-icon--filled.svg`} alt="pin" />
            </button>
          </div>
          <div className="widget-box">
            <h1>Map Your Move</h1>
           {acceptedDisclaimer ?
             (<p>
                These tools are designed to help you learn more about the areas and neighborhoods in unincorporated Horry County.
                Whether you are looking to move, checking out a rental, or discovering more about where you live now, 
                the maps on this page will provide you with valuable local information. 
                It is important to be aware of local hazards unique to our area like hurricanes, flooding and wildfires. <br/><br/>
                In addition to learning what hazards exist, this page also provides resources to help you mitigate those hazards 
                and take the appropriate safety measures for yourself and your family. 
                You can also find information about your County Council district, school district, local utility providers, and more. 
                Keep in mind that these maps cannot possibly consider every potential scenario, 
                but instead this information is provided to give you information to consider for your planning purposes.<br/><br/>
              </p>) :
            (<div className="disclaimer">
              <h6>Disclaimer***</h6>
              <p>The data presented in this application is provided "as is" without warranty or any representation of accuracy, 
                timeliness or completeness. The burden for determining accuracy, completeness, timeliness, and fitness for or the 
                appropriateness for use rests solely on the user. Horry County makes no warranties, express or implied, as to the use of the data. 
                There are no implied warranties or warranties of fitness for a particular purpose or merchantability, and Horry County shall have 
                no liability for actual or consequential losses arising from use of the data. The Land Record data and mapping application represent 
                the parcel fabric as used for taxing purposes and not for survey purposes.</p>
              <div className="row"><button onClick={acceptDisclaimer}>Accept</button><button onClick={declineDisclaimer}>Decline</button></div>
            </div>)
          }
          </div>
        </div>
      </header>
    
      {acceptedDisclaimer && MAP_DATA.map(
        (data, index) => 
          <MapSection id={index} key={index} data={data} selectedDetailsIndex={selectedDetailsIndex} details={detailsInfo} />
      )}

      
      <footer className="option2">
          <div className="identifier column">
              <img src={`${BASE_URL}images/HCGovernment-footer-logo.svg`} alt="Horry County Official Logo" />

              <section className="column" >
                  <div className="row">
                      <a href="https://www.horrycounty.org"> www.horrycounty.org</a>&emsp;|&emsp;HC<strong>Government</strong>
                  </div>
                  <div className="row">
                      A product of Horry County Government
                  </div>
                  <div className="row">
                      ©2020 by Horry County Government&#8202;&mdash;&#8202;All Rights Reserved. 
                  </div>
              </section>
          </div>
          <div className="message">
              <p>This version of the website and associated maps is currently in beta-testing. This tool is still actively being developed, improved and updated. We appreciate your feedback! If you have bugs, issues, or other suggestions, please email us at <a href="mailto:mapyourmove@horrycounty.org">mapyourmove@horrycounty.org</a></p>
          </div>

      </footer>
    </>
  );
}

export default MainPage;
